/*
 * Created on 26.07.2016
 *
 * Copyright(c) 1995 - 2014 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormGroup } from '@angular/forms';

/**
 * Komponente zum Auswerten von HTTP 4XX-Fehlern zum Anzeigen der entsprechenden Fehlermeldungen
 * über einem Formular.
 *
 * @author Valentin Kennke (vake@mms-dresden.de)(valentin.kennke@t-systems.com)
 * @deprecated Use {@link HttpFormErrorService} instead.
 */
export class ErrorMessageService {

    /**
     * Funktion um die HttpErrorResponse von geworfenen BindExceptions in eine Fehlermeldung für das
     * Frontend umzuwandeln. Das ist hilfreich um backendseitige, feldgenaue Validierung zu ermöglichen.
     * Es geht nur um 4xx-Codes. 5xx-Codes werden von {@link HttpErrorInterceptor} und
     * {@link PortalEventService} verarbeitet.
     *
     * Diese Variante ist deprecated, daher wird noch zusätzlich der 5xx-Fall abgedeckt, wofür ein
     * "globalError"-Feld explizit im i18n erwartet wird.
     *
     * @param err der Http-Response
     * @param form die Form
     * @param globalMsgs Array von globalen Fehlermeldungen die über der Form angezeigt werden
     * @param msgs globale i18n-Messages
     * @deprecated Use {@link HttpFormErrorService#assignErrorsToForm} instead.
     */
    public static createErrorMessages(err: HttpErrorResponse, form: UntypedFormGroup, globalMsgs?: string[], msgs?: any) {
        switch (err.status) {
            case 400:
                // eslint-disable-next-line no-case-declarations
                const errObj = err.error;
                if (errObj.errors) {
                    errObj.errors.map(e => {
                        if (e.objectName === 'global') {
                            if (globalMsgs) {
                                globalMsgs.push(msgs[e.code]);
                            }
                        } else {
                            const error = {};
                            error[e.code] = true;
                            if (form.controls[e.objectName]) {
                                form.controls[e.objectName].setErrors(error);
                            }
                        }
                    });
                } else if (globalMsgs) {
                    // Dieser Codeblock ist für "normale" Exceptions; die Exception-Message wird
                    // direkt in das Array geschrieben
                    globalMsgs.push(errObj.message);
                }
                break;
            case 500:
                if (globalMsgs && msgs) {
                    globalMsgs.push(msgs['globalError']);
                }
                break;
        }
    }
}

